import { render, staticRenderFns } from "./ipComponent.vue?vue&type=template&id=2b58d454&scoped=true&"
import script from "./ipComponent.vue?vue&type=script&lang=js&"
export * from "./ipComponent.vue?vue&type=script&lang=js&"
import style0 from "./ipComponent.vue?vue&type=style&index=0&id=2b58d454&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58d454",
  null
  
)

export default component.exports